(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gbmc-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.gbmc-mobile-menu__nav a');
  if (link) link.closest('details').removeAttribute('open');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gbmc-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.gbmc-contact-disclosure').forEach(disclosure => {
  if (disclosure.querySelector('.gbmc-status')) disclosure.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gbmc-password"]) return;
  try {
    
document.querySelectorAll('.gbmc-password-entry').forEach(entry => {
  if (entry.querySelector('.gbmc-status--error')) entry.open = true;
});

  } catch(e) { console.error(e); }
})();
})();
